// ============================================================================
// POLISH TRANSLATIONS - BIBLE VERSES
// ============================================================================
// Kolekcja inspirujących wersetów z odniesieniami Strong

export const bibleVerses = [
  {
    reference: "Filipian 4:13",
    text: "Wszystko mogę w tym, który mnie wzmacnia",
    version: "biblia_gdanska",
    theme: "siła",
    strongNumbers: {
      "mogę": "G1411", // δύναμις (dynamis) = moc, siła
      "wzmacnia": "G1743" // ἐνδυναμόω (endynamoo) = wzmacniać
    },
    context: "Paweł mówi o swojej zdolności do stawiania czoła wszystkim sytuacjom dzięki Chrystusowi"
  },
  {
    reference: "Psalm 23:1",
    text: "Pan jest moim pasterzem, nie będę niczego potrzebował",
    version: "biblia_gdanska",
    theme: "ochrona",
    strongNumbers: {
      "pasterzem": "H7462", // רָעָה (ra'ah) = paść, strzec
      "potrzebował": "H2637" // חָסֵר (chaser) = brakować, potrzebować
    },
    context: "Dawid wyraża swoją całkowitą ufność w Boską Opatrzność"
  },
  {
    reference: "Jana 3:16",
    text: "Albowiem tak Bóg umiłował świat, że Syna swego jednorodzonego dał",
    version: "biblia_warszawska",
    theme: "miłość",
    strongNumbers: {
      "umiłował": "G25", // ἀγαπάω (agapao) = kochać bezwarunkowo
      "dał": "G1325" // δίδωμι (didomi) = dawać, ofiarować
    },
    context: "Najsłynniejszy werset o miłości Boga do ludzkości"
  },
  {
    reference: "Filipian 4:7",
    text: "A pokój Boży, który przewyższa wszelki rozum, będzie strzegł waszych serc",
    version: "biblia_warszawska",
    theme: "pokój",
    strongNumbers: {
      "pokój": "G1515", // εἰρήνη (eirene) = pokój, harmonia
      "strzegł": "G5432" // φρουρέω (phroureo) = strzec, chronić
    },
    context: "Obietnica Boskiej ochrony przez wewnętrzny pokój"
  },
  {
    reference: "Psalm 119:105",
    text: "Słowo Twoje jest pochodnią nogom moim i światłością ścieżce mojej",
    version: "biblia_gdanska",
    theme: "przewodnictwo",
    strongNumbers: {
      "pochodnią": "H5216", // נִיר (niyr) = lampa, światło
      "światłością": "H216" // אוֹר (or) = światło, oświetlenie
    },
    context: "Słowo Boże jako przewodnik w codziennym życiu"
  },
  {
    reference: "Przypowieści 3:5-6",
    text: "Zaufaj Panu z całego serca swego i na swoim rozumie nie polegaj",
    version: "biblia_gdanska",
    theme: "zaufanie",
    strongNumbers: {
      "zaufaj": "H982", // בָּטַח (batach) = mieć ufność
      "serca": "H3820" // לֵב (leb) = serce, duch, wola
    },
    context: "Zachęta do ufania Bogu zamiast własnym zdolnościom"
  },
  {
    reference: "Mateusza 5:14",
    text: "Wy jesteście światłością świata. Nie może się ukryć miasto położone na górze",
    version: "biblia_warszawska",
    theme: "świadectwo",
    strongNumbers: {
      "światłością": "G5457", // φῶς (phos) = światło, duchowe oświecenie
      "świata": "G2889" // κόσμος (kosmos) = świat, wszechświat
    },
    context: "Jezus zachęca swoich uczniów do bycia świadkami w świecie"
  }
];

export default bibleVerses;
